module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-regular.f29d2b85.woff";